export function trackInitiateCheckout() {
  window.fbq?.('track', 'InitiateCheckout');
}
